import * as yup from 'yup';

import { validateEmail } from 'src/utils/validators/validate-email';
import { validatePassword } from 'src/utils/validators/validate-password';

import { userDataKeys } from '../details-form/constants';

const errorMessages = {
    email: {
        required: 'your_details_form_email_required',
        invalid: 'your_details_form_email_invalid',
    },
    password: {
        required: 'your_details_form_password_required',
        min: 'your_details_form_password_min',
        invalid: 'your_details_form_password_invalid',
    },
    repeatPassword: {
        required: 'your_details_form_repeat_password_required',
        invalid: 'your_details_form_repeat_password_invalid',
    },
};

export const createPasswordSchema = () =>
    yup.object().shape({
        [userDataKeys.email]: yup
            .string()
            .required(errorMessages.email.required)
            .test({ message: errorMessages.email.invalid, test: validateEmail }),
        [userDataKeys.password]: yup
            .string()
            .when(() =>
                yup
                    .string()
                    .required(errorMessages.password.required)
                    .min(8, errorMessages.password.min)
                    .test({ message: errorMessages.password.invalid, test: validatePassword })
            ),
        [userDataKeys.repeatPassword]: yup.string().when(() =>
            yup
                .string()
                .required(errorMessages.repeatPassword.required)
                .oneOf([yup.ref(userDataKeys.password)], errorMessages.repeatPassword.invalid)
        ),
    });
